// extracted by mini-css-extract-plugin
module.exports = {"coursesBlock":"CoursesBlock_coursesBlock__3lseR","blockHeader":"CoursesBlock_blockHeader__35RAs","courseCardList":"CoursesBlock_courseCardList__1LxcC"};